export default __webpack_public_path__ + "static/media/36I-102637_-15568_0.1601e2fd.jpg";